import { useTranslation } from "react-i18next";
/** Material UI Imports **/
import {
  Grid as MuiGrid,
  Divider as MuiDivider,
  Tooltip as MuiTooltip,
  Typography as MuiTypography,
} from "@mui/material";
import { Warning as MuiWarningIcon } from "@mui/icons-material";
/** Custom Component **/
import { convertDateStrToFLADateStr } from "app/shared/utils";

//Function to create the Current Appointments panel detail
export const CurrentAppointments = ({ facultyDetails }) => {
  // For fetching up the multilingual text object using i18next.
  const { t } = useTranslation();
  // Common string for translation key
  const currentApptDetailsLabels = "LeaveAccruedTaken.currentApptLabels";

  return (
    (facultyDetails.appointments &&
      facultyDetails.appointments.length > 0 &&
      facultyDetails.appointments.map((row, index) => (
        <div key={index}>
          <MuiGrid container key={index}>
            <MuiGrid size={12}>
              <MuiTypography color="textPrimary" variant="h2">
                {row.tier}
              </MuiTypography>
            </MuiGrid>
            <MuiGrid container size={11}>
              <MuiGrid size={5}>
                <MuiGrid container size={11}>
                  <MuiGrid size={4}>
                    <MuiTypography color="textPrimary">
                      {t(`${currentApptDetailsLabels}.apptFTE`)}:{" "}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid>
                    <MuiTypography color="textPrimary" sx={{ fontWeight: "600" }}>
                      {row.apptFte}
                    </MuiTypography>
                  </MuiGrid>
                </MuiGrid>
                <MuiGrid container size={11}>
                  <MuiGrid size={4}>
                    <MuiTypography color="textPrimary">
                      {t(`${currentApptDetailsLabels}.department`)}:{" "}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid container wrap="nowrap" size={6}>
                    <MuiTooltip
                      title={(row.department && row.department.name) || ""}
                      placement="bottom-start"
                    >
                      <MuiTypography
                        color="textPrimary"
                        noWrap
                        sx={{ fontWeight: "600" }}
                      >
                        {row.department && row.department.name}
                      </MuiTypography>
                    </MuiTooltip>
                  </MuiGrid>
                </MuiGrid>
                <MuiGrid container size={11}>
                  <MuiGrid size={4}>
                    <MuiTypography color="textPrimary">
                      {t(`${currentApptDetailsLabels}.rank`)}:{" "}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid container wrap="nowrap" size={6}>
                    <MuiTooltip title={row.rank} placement="bottom-start">
                      <MuiTypography
                        color="textPrimary"
                        noWrap
                        sx={{ fontWeight: "600" }}
                      >
                        {row.rank}
                      </MuiTypography>
                    </MuiTooltip>
                  </MuiGrid>
                </MuiGrid>
                <MuiGrid container size={11}>
                  <MuiGrid size={4}>
                    <MuiTypography color="textPrimary">
                      {t(`${currentApptDetailsLabels}.apptStart`)}:{" "}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid>
                    <MuiTypography color="textPrimary" sx={{ fontWeight: "600" }}>
                      {convertDateStrToFLADateStr(row.startDate)}
                    </MuiTypography>
                  </MuiGrid>
                </MuiGrid>
              </MuiGrid>
              <MuiGrid size={5}>
                <MuiGrid container>
                  <MuiGrid size={2}>
                    <MuiTypography color="textPrimary">
                      {t(`${currentApptDetailsLabels}.school`)}:{" "}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid container size={9} spacing={1}>
                    <MuiGrid>
                      <MuiTypography color="textPrimary" sx={{ fontWeight: "600" }}>
                        {row.school.name}
                      </MuiTypography>
                    </MuiGrid>
                    <MuiGrid>
                      {!row.schoolOfMedicine && (
                        <MuiTooltip
                          title={t(
                            `${currentApptDetailsLabels}.schoolTooltipText`,
                          )}
                          placement="right"
                        >
                          <MuiWarningIcon fontSize="small" fontWeight="600" />
                        </MuiTooltip>
                      )}
                    </MuiGrid>
                  </MuiGrid>
                </MuiGrid>
                <MuiGrid container>
                  <MuiGrid size={2}>
                    <MuiTypography color="textPrimary">
                      {t(`${currentApptDetailsLabels}.division`)}:{" "}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid container size={8} wrap="nowrap">
                    {row.division && (
                      <MuiTooltip
                        title={row.division.name || ""}
                        placement="bottom-start"
                      >
                        <MuiTypography
                          color="textPrimary"
                          noWrap
                          sx={{ fontWeight: "600" }}
                        >
                          {row.division.name}
                        </MuiTypography>
                      </MuiTooltip>
                    )}
                  </MuiGrid>
                </MuiGrid>
                <MuiGrid container>
                  <MuiGrid size={2}>
                    <MuiTypography color="textPrimary">
                      {t(`${currentApptDetailsLabels}.line`)}:{" "}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid>
                    <MuiTypography color="textPrimary" sx={{ fontWeight: "600" }}>
                      {row.facultyLine.abbreviation} {row.facultyLine.text}
                    </MuiTypography>
                  </MuiGrid>
                </MuiGrid>
                <MuiGrid container>
                  <MuiGrid size={2}>
                    <MuiTypography color="textPrimary">
                      {t(`${currentApptDetailsLabels}.apptEnd`)}:{" "}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid>
                    <MuiTypography color="textPrimary" sx={{ fontWeight: "600" }}>
                      {convertDateStrToFLADateStr(row.endDate)}
                    </MuiTypography>
                  </MuiGrid>
                </MuiGrid>
              </MuiGrid>
            </MuiGrid>
          </MuiGrid>
          {index < facultyDetails.appointments.length - 1 && (
            <MuiDivider sx={{ margin: "10px -16px 10px -16px" }} />
          )}
        </div>
      ))) ||
    null
  );
};
